var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C7.12541 0 2.54363 3.39219 0.777466 8.1522H24.2225C22.4563 3.39219 17.8745 0 12.5 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C17.8745 25 22.4563 21.6078 24.2225 16.8478H0.777466C2.54363 21.6078 7.12541 25 12.5 25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8478 11.1413H13.5869C13.5869 10.541 13.1002 10.0543 12.5 10.0543C11.8997 10.0543 11.413 10.541 11.413 11.1413H8.1521C8.1521 11.7416 8.675 12.2283 9.27529 12.2283H9.23906C9.23906 12.8286 9.72568 13.3152 10.326 13.3152C10.326 13.9156 10.8126 14.4022 11.413 14.4022H13.5869C14.1873 14.4022 14.6739 13.9156 14.6739 13.3152C15.2742 13.3152 15.7608 12.8286 15.7608 12.2283H15.7247C16.3249 12.2283 16.8478 11.7416 16.8478 11.1413Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/egypt.f8762bd3b050e3864c3af73e02605981.svg";
export { ForwardRef as ReactComponent };